import { render, staticRenderFns } from "./PortalUpdateModal.vue?vue&type=template&id=3467a370&scoped=true"
import script from "./PortalUpdateModal.vue?vue&type=script&lang=js"
export * from "./PortalUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./PortalUpdateModal.vue?vue&type=style&index=0&id=3467a370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467a370",
  null
  
)

export default component.exports